var data = require("../../data/dzud.sheet.json");
var { isMobile, isTablet, isDesktop } = require("./lib/breakpoints");
var $ = require("./lib/qsa");

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var wrapText = require("./lib/wrapText");
var makeTranslate = require("./lib/makeTranslate");
var debounce = require("./lib/debounce");

var fmtComma = s => s.toLocaleString().replace(/\.0+$/, "");
var fmtYearAbbrev = d => (d.getFullYear() + "").slice(-2);
var fmtYearFull = d => d.getFullYear();

renderDzud();
window.addEventListener("resize", debounce(renderDzud));

function renderDzud() {
  // Setup chart container
  var labelColumn = "label";
  var valueColumn = "amt";

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 9;
  var valueGap = 6;

  var margins = {
    top: 50,
    right: 40,
    bottom: 50,
    left: 35
  };

  var ticksY = 4;
  var ticksX = 5;
  var roundTicksFactor = 5;

  var container = document.querySelector(".graphic.dzud .container");
  // Calculate actual chart dimensions
  var chartWidth = container.offsetWidth - margins.left - margins.right;
  var chartHeight =
    Math.ceil((container.offsetWidth * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  //clear for redraw
  var containerElement = d3.select(container);
  containerElement.html("");

  var chartElement = containerElement
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 scale objects.
  var xScale = d3
    .scaleBand()
    .range([0, chartWidth])
    .round(true)
    .padding(0.1)
    .domain(data.map(d => d[labelColumn]));

  var floors = data.map(
    d => Math.floor(d[valueColumn] / roundTicksFactor) * roundTicksFactor
  );

  var min = Math.min(...floors);

  if (min > 0) {
    min = 0;
  }

  var ceilings = data.map(
    d => Math.ceil(d[valueColumn] / roundTicksFactor) * roundTicksFactor
  );

  var max = Math.max(...ceilings);

  var yScale = d3
    .scaleLinear()
    .domain([min, max])
    .range([chartHeight, 0]);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .tickValues(
      xScale.domain().filter(function(d, i) {
        if(isMobile.matches) return !((i + 1) % 10);
        else return (
          !((i + 1) % 5) || (!isMobile.matches && (d == 1971 || d == 2018))
        );
      })
    );

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(d => d + "%");

  // Render axes to chart.
  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("aria-hidden", "true")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement
    .append("g")
    .attr("class", "y axis")
    .attr("aria-hidden", "true")
    .call(yAxis);

  // Render bars to chart.
  chartElement
    .append("g")
    .attr("class", "bars")
    .selectAll("rect")
    .data(data)
    .enter()
    .append("rect")
    .attr("x", d => xScale(d[labelColumn]))
    .attr("y", d => (d[valueColumn] < 0 ? yScale(0) : yScale(d[valueColumn])))
    .attr("width", xScale.bandwidth())
    .attr("height", d =>
      d[valueColumn] < 0
        ? yScale(d[valueColumn]) - yScale(0)
        : yScale(0) - yScale(d[valueColumn])
    )
    .attr("class", function(d) {
      return "bar bar-" + d[labelColumn];
    });

  // Render 0 value line.
  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", 0)
      .attr("x2", chartWidth)
      .attr("y1", yScale(0))
      .attr("y2", yScale(0));
  }

//2000-2002 annotation
var annotation = chartElement.append('g')
    .attr('class', 'annotation');
  annotation.append('line')
    .attr('x1', xScale(2000))
    .attr('x2', xScale(2003))
    .attr('y1', yScale(16))
    .attr('y2', yScale(16));
  annotation.append('line')
    .attr('x1', xScale(2000))
    .attr('x2', xScale(2000))
    .attr('y1', yScale(16.05))
    .attr('y2', yScale(15.7));

  annotation.append('line')
    .attr('x1', xScale(2003))
    .attr('x2', xScale(2003))
    .attr('y1', yScale(16.05))
    .attr('y2', yScale(15.7));
  // annotation.append('circle')
  //   .attr('cx', xScale('1963'))
  //   .attr('cy', annotation.select('line').attr('y1'))
  //   .attr('r', 3);
  annotation.append('text')
    .text('11.2 million livestock perished during the winters of 1999-2002.')
    .attr('x', function(){
      var x = xScale('1998');
      if(isTablet.matches) x = xScale('1990')
      if(isMobile.matches) x = xScale('1985');
      return x;
    })
    .attr('y', function(){
      var y = yScale(16) -30;
      return y;
    })
    .attr('dx', -5)
    .call(wrapText, 140, 13);

//2010 annotation
var annotation2 = chartElement.append('g')
    .attr('class', 'annotation two');
annotation2.append('text')
    .text("Mongolia's harshest dzud killed 10.3 million livestock during the 2009-2010 winter.")
    .attr('x', function(){
        var x = xScale('2012')+5;
        return x;
    })
    .attr('y', function(){
      var y = yScale(24);
      if(isMobile.matches) y = yScale(23);
      return y;
    })
    .attr('dx', -5)
    .call(wrapText, 65, 13);
annotation2.append('line')
    .attr('x1', xScale(2010)+5)
    .attr('x2', xScale(2011)+5)
    .attr('y1', yScale(23))
    .attr('y2', yScale(23));

// //make dzud italic
var textElement = $.one(".annotation.two text");
// console.log(textElement.children);
for (var i = 0; i < textElement.children.length; i++) {
  textElement.children[i].innerHTML = textElement.children[i].innerHTML.replace(/dzud/g, `<tspan class="i">dzud</tspan>`);
}

};
